import React from 'react';
import { toast } from 'sonner';
import axios from 'axios';
import { getAuthHeader } from '../../services/tokenService';
import BackButton from '../../components/BackButton';
import { useNomenclature } from './useNomenclature';
import NomenclatureContent from './NomenclatureContent';
import NomenclatureDialogs from './NomenclatureDialogs';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function NomenclatureManagement() {
  const ctx = useNomenclature();
  const { nomenclatures, loading, selectedIds, setShowEstimatorDialog, estimatorConfig, setEstimatorConfig, fetchNomenclatures, deselectAll } = ctx;

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        
      {/* Bouton Retour */}
      <BackButton label="Retour" />

<div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-500 border-t-transparent"></div>
      </div>
    );
  }


  // Fonction pour lier/délier l'estimateur
  const handleBulkEstimatorUpdate = async () => {
    if (selectedIds.size === 0) {
      toast.error('Aucune nomenclature sélectionnée');
      return;
    }

    try {
      const config = {
        enabled: estimatorConfig.enabled,
        coefficient: estimatorConfig.coefficient ? parseFloat(estimatorConfig.coefficient) : null,
        min_ca: estimatorConfig.min_ca ? parseFloat(estimatorConfig.min_ca) : null,
        max_ca: estimatorConfig.max_ca ? parseFloat(estimatorConfig.max_ca) : null
      };


      const response = await axios.post(
        `${BACKEND_URL}/api/nomenclatures/estimator/bulk-update`,
        {
          nomenclature_ids: Array.from(selectedIds),
          estimator_config: config
        },
        { headers: getAuthHeader() }
      );

      const successMsg = response.data.synced_count 
        ? `${response.data.modified_count} nomenclature(s) liée(s) à l'estimateur (${response.data.synced_count} activité(s) synchronisée(s))`
        : `${response.data.modified_count} nomenclature(s) liée(s) à l'estimateur`;
      toast.success(successMsg);
      setShowEstimatorDialog(false);
      setEstimatorConfig({ enabled: false, coefficient: '', min_ca: '', max_ca: '' });
      deselectAll();
      fetchNomenclatures();
    } catch (error) {
      const errorMessage = error.response?.data?.detail || error.message || 'Erreur lors de la mise à jour';
      toast.error(errorMessage);
    }
  };



  return (
    <div className="space-y-6">
      <NomenclatureDialogs ctx={{ ...ctx, handleBulkEstimatorUpdate }} />
      <NomenclatureContent ctx={ctx} />
    </div>
  );
}
